/**
 * Principal types that define what kind of entity the user is
 * USER = Regular users (permissions come from RBAC UserRole table)
 * PLATFORM_ADMIN = Platform super-admin (bypasses all RBAC, full system access)
 * SERVICE = Service-to-service tokens (bypasses RBAC)
 * AUTOMATION = System automation/scheduled tasks (bypasses RBAC)
 */
export type PrincipalType = 'USER' | 'PLATFORM_ADMIN' | 'SERVICE' | 'AUTOMATION';

/**
 * Check if a principal type bypasses RBAC
 */
export const bypassesRbac = (principalType: PrincipalType | undefined): boolean => {
  return principalType !== undefined && principalType !== 'USER';
};

/**
 * Map legacy role values to PrincipalType
 * Used for backward compatibility with JWT tokens that still use role field
 */
export const getPrincipalTypeFromRole = (role: string | null | undefined): PrincipalType => {
  if (!role) return 'USER';
  switch (role.toUpperCase()) {
    case 'SKU':
      return 'PLATFORM_ADMIN';
    case 'SERVICE':
      return 'SERVICE';
    case 'SYSTEM':
      return 'AUTOMATION';
    default:
      return 'USER';
  }
};
